import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import BlogHome from "./blogs/BlogHome";
import "../styles/home.css";

const ICONS = {
  server:
    '<rect x="3.5" y="4" width="17" height="6.5" rx="2"/><rect x="3.5" y="13.5" width="17" height="6.5" rx="2"/><path d="M7.5 7.2h.01M7.5 16.8h.01M12 7.2h5M12 16.8h5"/>',
  bot: '<rect x="4.5" y="8.5" width="15" height="10.5" rx="3.5"/><path d="M12 8.5V5M9.8 5h4.4M2.5 12.5v3M21.5 12.5v3"/><circle cx="9.3" cy="13.4" r="1.1"/><circle cx="14.7" cy="13.4" r="1.1"/><path d="M9.5 16.4h5"/>',
  camera:
    '<path d="M3.5 9A2.5 2.5 0 0 1 6 6.5h1.5l1.2-1.8A1 1 0 0 1 9.5 4.3h5a1 1 0 0 1 .8.4l1.2 1.8H18A2.5 2.5 0 0 1 20.5 9v8A2.5 2.5 0 0 1 18 19.5H6A2.5 2.5 0 0 1 3.5 17z"/><circle cx="12" cy="13" r="3.6"/>',
  shield:
    '<path d="M12 3l7.5 3v5.5c0 4.5-3.1 8-7.5 9.5-4.4-1.5-7.5-5-7.5-9.5V6z"/><path d="M8.8 12l2.3 2.3 4.2-4.6"/>',
  cpu: '<rect x="6" y="6" width="12" height="12" rx="2.5"/><rect x="9.5" y="9.5" width="5" height="5" rx="1"/><path d="M9 2.5V6M15 2.5V6M9 18v3.5M15 18v3.5M2.5 9H6M2.5 15H6M18 9h3.5M18 15h3.5"/>',
  eye: '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  globe:
    '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18"/>',
  users:
    '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.4-3.6 3-5.5 6.5-5.5s6.1 1.9 6.5 5.5"/><path d="M16 4.8a3.4 3.4 0 0 1 0 6.4M18 14.8c2 .6 3.3 2.3 3.5 5.2"/>',
  layers:
    '<path d="M12 3l9 5-9 5-9-5z"/><path d="M3 12.5l9 5 9-5M3 16.5l9 5 9-5"/>',
  brief:
    '<rect x="3" y="7" width="18" height="13" rx="3"/><path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7M3 13h18"/>',
  check: '<circle cx="12" cy="12" r="9"/><path d="M8 12.5l3 3 5-6"/>',
  arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
  download: '<path d="M12 4v11M7.5 10.5L12 15l4.5-4.5M5 20h14"/>',
  phone:
    '<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/>',
  pin: '<path d="M12 21s7-5.6 7-11a7 7 0 0 0-14 0c0 5.4 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/>',
};

/* ---------------- CONTENT: edit freely (taken from the company brochure) ---------------- */

const HERO_CHIPS = [
  { icon: "server", label: "Enterprise IT" },
  { icon: "bot", label: "Robotics & AMRs" },
  { icon: "camera", label: "AI Video Analytics" },
  { icon: "shield", label: "Cyber Security" },
];

const STATS = [
  {
    icon: "server",
    count: 99.999,
    dec: 3,
    from: 99,
    suffix: "%",
    label: "High-availability SLA",
  },
  { icon: "clock", text: "24/7/365", label: "Proactive NOC & SOC" },
  { icon: "eye", text: "< 1 Sec", label: "Edge AI vision inference" },
  { icon: "globe", count: 1, dec: 0, from: 0, label: "Global delivery hubs" },
];

// Replace "mono" with a real logo by adding  logo: "/images/clients/name.svg"
const CLIENTS = [
  {
    name: "Google IT Services",
    mono: "G",
    note: "Hyperscale infrastructure support",
  },
  {
    name: "SBISGCSL (SBI-SG)",
    mono: "S",
    note: "BFSI high-security custodial IT",
  },
  {
    name: "Marriott Hotels",
    mono: "M",
    note: "Campus Wi-Fi and AI surveillance",
  },
  {
    name: "ISKCON (BBT)",
    mono: "I",
    note: "Wide-area campus IT and telemetry",
  },
];

const SERVICES = [
  {
    icon: "server",
    tag: "Digital core",
    title: "Enterprise Infrastructure & Cloud",
    text: "The resilient foundation your business runs on, designed, built and operated end to end.",
    points: [
      [
        "Turnkey data centers",
        "High-density compute, SAN/NAS storage, modular server racks and hyperconverged architectures.",
      ],
      [
        "Hybrid cloud migration",
        "Workload profiling, automated migration to AWS, Azure and GCP, DRaaS and FinOps cost optimization.",
      ],
      [
        "Next-gen networking",
        "Resilient SD-WAN backbones, Wi-Fi 6/7 campus fabrics and unified collaboration infrastructure.",
      ],
    ],
    to: "/services/cloud-computing",
    cta: "Explore cloud services",
  },
  {
    icon: "bot",
    tag: "Next-gen robotics",
    title: "Robotics & Autonomous Mobile Systems",
    text: "Autonomous machines that move, inspect and report, integrated with the systems you already use.",
    points: [
      [
        "Autonomous mobile robots (AMRs)",
        "Industrial ROS 2 chassis, 3D LiDAR and visual SLAM, dynamic avoidance and auto-docking.",
      ],
      [
        "Inspection and telemetry AMRs",
        "Autonomous platforms for RF spectrum scanning, thermal mapping and data hall patrols.",
      ],
      [
        "Fleet orchestration",
        "Centralized multi-robot management integrated directly with enterprise ERP, MES and WMS.",
      ],
    ],
    to: "/contact-us",
    cta: "Request an AMR proof of concept",
  },
  {
    icon: "camera",
    tag: "Edge vision",
    title: "AI Video Analytics & Vision",
    text: "Intelligence at the camera: events detected and acted on in under a second.",
    points: [
      [
        "Real-time computer vision",
        "Edge-deployed deep neural networks analyzing live HD streams with sub-second latency.",
      ],
      [
        "Intrusion and perimeter defense",
        "Automated virtual tripwires, geofence breaches, unauthorized tracking and ANPR.",
      ],
      [
        "Operational safety and compliance",
        "Real-time PPE compliance verification, heatmaps, loitering alerts and audit logging.",
      ],
    ],
    to: "/contact-us",
    cta: "Talk to our vision team",
  },
  {
    icon: "shield",
    tag: "Lifecycle support",
    title: "Cyber Security & Managed Services",
    text: "Continuous protection and care, from the first audit through years of operation.",
    points: [
      [
        "Zero-trust and cyber defense",
        "Continuous SOC monitoring, EDR/XDR threat detection, vulnerability audits and pen testing.",
      ],
      [
        "Strategic IT advisory",
        "Vendor-agnostic architecture audits, capacity sizing and technology lifecycle roadmapping.",
      ],
      [
        "24/7 SLA managed services",
        "Proactive system telemetry, automated patch compliance and dedicated enterprise SLAs.",
      ],
    ],
    to: "/services/cyber-security",
    cta: "Explore cyber security",
  },
];

const WHY = [
  {
    icon: "users",
    title: "One engineering team",
    text: "IT, robotics, AI vision and cyber security under one roof, so your systems work as a single whole.",
  },
  {
    icon: "server",
    title: "99.999% availability SLA",
    text: "High-availability architecture backed by dedicated enterprise service levels.",
  },
  {
    icon: "clock",
    title: "24/7/365 NOC and SOC",
    text: "Proactive monitoring and response around the clock, not only during office hours.",
  },
  {
    icon: "cpu",
    title: "Sub-second edge AI",
    text: "Vision inference at the camera, so events are detected and acted on in under a second.",
  },
  {
    icon: "layers",
    title: "Vendor-agnostic design",
    text: "Architecture, sizing and roadmaps built around your needs, not around one vendor catalogue.",
  },
  {
    icon: "brief",
    title: "Turnkey delivery",
    text: "Build-out, migration and on-site proof of concept handled end to end by the same team.",
  },
];

// Short descriptions below only restate the engagement type. Replace with real case-study text and links.
const WORK = [
  {
    img: "/assets/images/home/work-infra.jpg",
    tag: "Data center and cloud",
    client: "Google IT Services",
    scope: "Hyperscale infrastructure support",
    text: "Keeping large-scale infrastructure supported, monitored and running to demanding service levels.",
    alt: "Illustration of a server hall under a 99.999% uptime cloud",
  },
  {
    img: "/assets/images/home/work-bfsi.jpg",
    tag: "BFSI",
    client: "SBISGCSL (SBI-SG)",
    scope: "BFSI high-security custodial IT",
    text: "Security-first IT for a regulated custodial environment, where protection and uptime both matter.",
    alt: "Illustration of a bank building protected by a shield",
  },
  {
    img: "/assets/images/home/work-hotel.jpg",
    tag: "Hospitality",
    client: "Marriott Hotels",
    scope: "Campus Wi-Fi and AI surveillance",
    text: "Campus-wide Wi-Fi paired with AI-assisted video surveillance for guests and staff.",
    alt: "Illustration of a hotel tower with Wi-Fi and an AI camera",
  },
  {
    img: "/assets/images/home/work-campus.jpg",
    tag: "Campus and telemetry",
    client: "ISKCON (BBT)",
    scope: "Wide-area campus IT and telemetry",
    text: "Connected IT and telemetry across a wide-area campus, managed from one place.",
    alt: "Illustration of campus buildings linked to a central tower",
  },
];

const STEPS = [
  { title: "Assess", text: "Architecture review and infrastructure audit." },
  { title: "Architect", text: "Vendor-agnostic design, sizing and roadmap." },
  {
    title: "Deploy",
    text: "Turnkey build-out, migration and on-site proof of concept.",
  },
  {
    title: "Operate",
    text: "24/7 NOC and SOC with dedicated enterprise SLAs.",
  },
];

// Replace "mono" with a real logo by adding  logo: "/images/partners/aws.svg"
const PARTNERS = [
  {
    name: "Amazon Web Services",
    short: "AWS",
    note: "Workload migration, DRaaS and FinOps",
  },
  {
    name: "Microsoft Azure",
    short: "Azure",
    note: "Hybrid cloud design and migration",
  },
  {
    name: "Google Cloud",
    short: "GCP",
    note: "Cloud-native builds and cost optimization",
  },
];

const LIFE_POINTS = [
  "Work on real mission-critical systems",
  "Learn across IT, robotics, AI and cyber security",
  "Collaborate with teams in the USA",
];

// x / y are percentages of the map image
const HUBS = [
  // {
  //   id: "thane",
  //   city: "Thane",
  //   region: "India",
  //   role: "India HQ",
  //   x: 69.92,
  //   y: 44.26,
  // },
  // {
  //   id: "bengaluru",
  //   city: "Bengaluru",
  //   region: "India",
  //   role: "Karnataka",
  //   x: 71.38,
  //   y: 48.98,
  // },
  // {
  //   id: "new-delhi",
  //   city: "New Delhi",
  //   region: "India",
  //   role: "NCR",
  //   x: 70.62,
  //   y: 37.13,
  // },
  // {
  //   id: "dubai",
  //   city: "Dubai",
  //   region: "UAE",
  //   role: "Middle East",
  //   x: 64.89,
  //   y: 39.72,
  // },
  {
    id: "austin",
    city: "Austin",
    region: "United States",
    role: "Texas",
    x: 24.03,
    y: 35.86,
  },
];

const CONTACT = { phoneHref: "tel:+917977353388", bigPhone: "79773 53388" };

/* ---------------- helpers ---------------- */

function Icon({ name, sw = 1.8 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  );
}

function CountUp({ to, dec = 0, from = 0 }) {
  const [n, setN] = useState(to);
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (
      !el ||
      !("IntersectionObserver" in window) ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )
      return;
    let raf;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        const t0 = performance.now();
        const tick = (t) => {
          const p = Math.min((t - t0) / 1500, 1);
          setN(from + (to - from) * (1 - Math.pow(1 - p, 3)));
          if (p < 1) raf = requestAnimationFrame(tick);
        };
        setN(from);
        raf = requestAnimationFrame(tick);
      },
      { threshold: 0.4 },
    );
    io.observe(el);
    return () => {
      io.disconnect();
      cancelAnimationFrame(raf);
    };
  }, [to, from]);
  return <span ref={ref}>{n.toFixed(dec)}</span>;
}

/* Fades sections in as they scroll into view. Without JS or with reduced motion everything is simply visible. */
function useReveal() {
  const ref = useRef(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const root = ref.current;
    if (
      !root ||
      !("IntersectionObserver" in window) ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )
      return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const el = e.target;
            el.classList.add("is-in");
            io.unobserve(el);
            // hand the element back to its normal hover transitions once the fade-in has finished
            const d = parseFloat(el.style.getPropertyValue("--i")) || 0;
            setTimeout(() => el.removeAttribute("data-rv"), 900 + d * 90);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -6% 0px" },
    );
    root.querySelectorAll("[data-rv]").forEach((el) => io.observe(el));
    setReady(true);
    return () => io.disconnect();
  }, []);
  return [ref, ready];
}

const delay = (i) => ({ "--i": i });

export default function Home() {
  const [rootRef, ready] = useReveal();
  const [hub, setHub] = useState("austin");

  useEffect(() => {
    const previous = document.title;
    document.title =
      "Global Tech9 LLC - Enterprise IT, Robotics, AI Vision and Cyber Security";
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <main className={`gt9-hm${ready ? " is-ready" : ""}`} ref={rootRef}>
      {/* ---------- Hero ---------- */}
      <section className="gt9-hero">
        <div className="gt9-container gt9-hero__grid">
          <div className="gt9-hero__text">
            <span className="gt9-eyebrow">Global Tech9 LLC</span>
            <h1 className="gt9-hero__title">
              Architects of <span className="hl">Innovation</span>
            </h1>
            <p className="gt9-hero__tag">
              Converging resilient core IT with autonomous edge intelligence.
            </p>
            <p className="gt9-hero__lead">
              We design, deploy and run enterprise IT infrastructure, advanced
              robotics, AI video analytics and managed cyber security, as one
              accountable team for mission-critical organizations.
            </p>
            <div className="gt9-actions">
              <a href="#solutions" className="gt9-btn gt9-btn--gold">
                Explore our solutions <Icon name="arrow" sw={2} />
              </a>
              <Link
                to="/contact-us"
                className="gt9-btn gt9-btn--ghost"
                style={{ boxShadow: "unset" }}
              >
                Talk to our team
              </Link>
            </div>
            <ul className="gt9-hero__chips" aria-label="Capabilities">
              {HERO_CHIPS.map((c) => (
                <li key={c.label}>
                  <Icon name={c.icon} />
                  {c.label}
                </li>
              ))}
            </ul>
          </div>
          <div className="gt9-hero__art">
            <img
              src="/assets/images/home/hero-5.webp"
              alt="Illustration of a cloud with an AI chip linked to a data center, security shield, AI camera and robotic arm"
              width="1200"
              height="947"
            />
          </div>
        </div>
      </section>

      {/* ---------- Key figures ---------- */}
      <section className="gt9-facts" aria-label="Company highlights">
        <div className="gt9-container">
          <div className="gt9-facts__grid" data-rv>
            {STATS.map((s) => (
              <div className="gt9-fact" key={s.label}>
                <i>
                  <Icon name={s.icon} />
                </i>
                <div>
                  <b>
                    {s.count !== undefined ? (
                      <>
                        <CountUp to={s.count} dec={s.dec} from={s.from} />
                        {s.suffix}
                      </>
                    ) : (
                      s.text
                    )}
                  </b>
                  <span className="gt9-fact__l">{s.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- Trusted by ---------- */}
      <section
        className="gt9-trust"
        id="trusted"
        aria-labelledby="gt9-trust-title"
      >
        <div className="gt9-container">
          <div className="gt9-trust__head" data-rv>
            <div>
              <span className="gt9-eyebrow">Trusted by</span>
              <h2 id="gt9-trust-title" className="gt9-h2 gt9-h2--sm">
                A proven mission-critical track record
              </h2>
            </div>
            <span className="gt9-pill">
              <Icon name="check" sw={2} /> Enterprise verified
            </span>
          </div>
          <ul className="gt9-clients">
            {CLIENTS.map((c, i) => (
              <li className="gt9-client" key={c.name} data-rv style={delay(i)}>
                <span className="gt9-client__logo">
                  {c.logo ? <img src={c.logo} alt="" loading="lazy" /> : c.mono}
                </span>
                <b>{c.name}</b>
                <span>{c.note}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* ---------- Products and services ---------- */}
      <section
        className="gt9-sec gt9-sec--tint"
        id="solutions"
        aria-labelledby="gt9-sol-title"
      >
        <div className="gt9-container">
          <div className="gt9-head gt9-head--split" data-rv>
            <div>
              <span className="gt9-eyebrow">What we deliver</span>
              <h2 id="gt9-sol-title">Four capabilities, one integrated team</h2>
              <p>
                Choose a single solution or combine them. Everything is
                engineered to work together and backed by the same 99.999%
                availability SLA and 24/7/365 proactive NOC and SOC.
              </p>
            </div>
            <Link to="/contact-us" className="gt9-btn gt9-btn--line">
              Plan your project <Icon name="arrow" sw={2} />
            </Link>
          </div>
          <div className="gt9-cards">
            {SERVICES.map((s, i) => (
              <article
                className="gt9-svc"
                key={s.title}
                data-rv
                style={delay(i % 2)}
              >
                <div className="gt9-svc__top">
                  <i>
                    <Icon name={s.icon} />
                  </i>
                  <span className="gt9-chip">{s.tag}</span>
                </div>
                <h3>{s.title}</h3>
                <p className="gt9-svc__lead">{s.text}</p>
                <ul className="gt9-svc__list">
                  {s.points.map(([t, d]) => (
                    <li key={t}>
                      <Icon name="check" sw={2} />
                      <div>
                        <b>{t}</b> {d}
                      </div>
                    </li>
                  ))}
                </ul>
                <Link className="gt9-more" to={s.to}>
                  {s.cta} <Icon name="arrow" sw={2} />
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- Why choose us ---------- */}
      <section
        className="gt9-sec gt9-sec--white"
        id="why"
        aria-labelledby="gt9-why-title"
      >
        <div className="gt9-container">
          <div className="gt9-why">
            <div className="gt9-why__intro" data-rv>
              <span className="gt9-eyebrow">Why choose us</span>
              <h2 id="gt9-why-title" className="gt9-h2">
                One accountable partner for the digital core and the autonomous
                edge
              </h2>
              <p>
                Global Tech9 LLC designs, deploys and runs the technology that
                keeps mission-critical organizations moving, so your systems
                work as a single, resilient whole instead of separate projects.
              </p>
              <Link to="/about-us" className="gt9-btn gt9-btn--gold">
                About our company <Icon name="arrow" sw={2} />
              </Link>
            </div>
            <div className="gt9-why__grid">
              {WHY.map((w, i) => (
                <article
                  className="gt9-feat"
                  key={w.title}
                  data-rv
                  style={delay(i % 2)}
                >
                  <i>
                    <Icon name={w.icon} />
                  </i>
                  <h3>{w.title}</h3>
                  <p>{w.text}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ---------- Past work ---------- */}
      <section
        className="gt9-sec gt9-sec--navy"
        id="work"
        aria-labelledby="gt9-work-title"
      >
        <div className="gt9-container">
          <div className="gt9-head gt9-head--split" data-rv>
            <div>
              <span className="gt9-eyebrow">Our past work</span>
              <h2 id="gt9-work-title">Mission-critical projects, delivered</h2>
              <p>
                A look at the kinds of environments we have supported, from
                hyperscale infrastructure to high-security BFSI and wide-area
                campuses.
              </p>
            </div>
            <Link
              to="/contact-us"
              className="gt9-btn gt9-btn--ghost"
              style={{ boxShadow: "unset" }}
            >
              Discuss your project <Icon name="arrow" sw={2} />
            </Link>
          </div>
          <div className="gt9-works">
            {WORK.map((w, i) => (
              <article
                className="gt9-work"
                key={w.client}
                data-rv
                style={delay(i)}
              >
                <div className="gt9-work__media">
                  <img
                    src={w.img}
                    alt={w.alt}
                    width="960"
                    height="720"
                    loading="lazy"
                  />
                  <span className="gt9-chip gt9-chip--gold">{w.tag}</span>
                </div>
                <div className="gt9-work__body">
                  <h3>{w.client}</h3>
                  <span className="gt9-work__scope">{w.scope}</span>
                  <p>{w.text}</p>
                  <Link className="gt9-more" to="/contact-us">
                    Discuss a similar project <Icon name="arrow" sw={2} />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ---------- How we work ---------- */}
      <section
        className="gt9-sec gt9-sec--white"
        id="how"
        aria-labelledby="gt9-how-title"
      >
        <div className="gt9-container">
          <div className="gt9-head gt9-head--center" data-rv>
            <span className="gt9-eyebrow">How we work</span>
            <h2 id="gt9-how-title">From first audit to 24/7 operations</h2>
            <p>
              Four clear steps, handled by one team, so nothing is lost in
              hand-offs.
            </p>
          </div>
          <ol className="gt9-steps">
            {STEPS.map((s, i) => (
              <li className="gt9-step" key={s.title} data-rv style={delay(i)}>
                <div className="gt9-step__no">{i + 1}</div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* ---------- Partners ---------- */}
      <section
        className="gt9-sec gt9-sec--tint gt9-sec--compact"
        id="partners"
        aria-labelledby="gt9-par-title"
      >
        <div className="gt9-container">
          <div className="gt9-head gt9-head--center" data-rv>
            <span className="gt9-eyebrow">Our partners</span>
            <h2 id="gt9-par-title">Built on the platforms you already trust</h2>
            <p>
              We design vendor-agnostic, so the right platform is chosen for
              your workload, not for ours.
            </p>
          </div>
          <ul className="gt9-partners">
            {PARTNERS.map((p, i) => (
              <li className="gt9-partner" key={p.name} data-rv style={delay(i)}>
                <span className="gt9-partner__logo">
                  {p.logo ? (
                    <img src={p.logo} alt={p.name} loading="lazy" />
                  ) : (
                    p.short
                  )}
                </span>
                <b>{p.name}</b>
                <span>{p.note}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* ---------- Life at the company ---------- */}
      <section
        className="gt9-sec gt9-sec--white"
        id="life"
        aria-labelledby="gt9-life-title"
      >
        <div className="gt9-container">
          <div className="gt9-life">
            <div className="gt9-life__text" data-rv>
              <span className="gt9-eyebrow">Life at Global Tech9 LLC</span>
              <h2 id="gt9-life-title" className="gt9-h2">
                Where curious engineers build what comes next
              </h2>
              <p>
                We bring enterprise IT, robotics, AI vision and cyber security
                together in one team. That means there is always something new
                to learn, and someone close by to learn it from.
              </p>
              <ul className="gt9-checks">
                {LIFE_POINTS.map((p) => (
                  <li key={p}>
                    <Icon name="check" sw={2} />
                    {p}
                  </li>
                ))}
              </ul>
              <div className="gt9-actions gt9-actions--dark">
                <Link to="/careers" className="gt9-btn gt9-btn--gold">
                  See open roles <Icon name="arrow" sw={2} />
                </Link>
                <Link to="/about-us" className="gt9-btn gt9-btn--line">
                  Meet the company
                </Link>
              </div>
            </div>
            <div className="gt9-collage" data-rv style={delay(1)}>
              <img
                className="gt9-collage__a"
                src="/assets/images/home/group-team.jpg"
                alt="Illustration of engineers working at desks in an office"
                width="1200"
                height="800"
                loading="lazy"
              />
              <img
                className="gt9-collage__b"
                src="/assets/images/home/growth.jpg"
                alt="Illustration of a person climbing steps toward a flag"
                width="800"
                height="600"
                loading="lazy"
              />
              <img
                className="gt9-collage__c"
                src="/assets/images/home/work-env.jpg"
                alt="Illustration of a team collaborating around a table"
                width="800"
                height="600"
                loading="lazy"
              />
              <div className="gt9-badge">
                <i>
                  <Icon name="globe" />
                </i>
                <div>
                  <b>USA</b>
                  <span>One team across region</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- Global presence ---------- */}
      <section
        className="gt9-sec gt9-sec--navy"
        id="presence"
        aria-labelledby="gt9-glo-title"
      >
        <div className="gt9-container">
          <div className="gt9-head" data-rv>
            <span className="gt9-eyebrow">Global presence</span>
            <h2 id="gt9-glo-title">One hub across single region</h2>
            <p>
              USA, with delivery teams in Austin supporting clients around the
              clock.
            </p>
          </div>
          <div className="gt9-glo" data-rv>
            <div className="gt9-map">
              <img
                src="/assets/images/home/global-presence-map.svg"
                alt=""
                width="760"
                height="324"
                loading="lazy"
              />
              {HUBS.map((h) => (
                <button
                  type="button"
                  key={h.id}
                  data-hub={h.id}
                  className={`gt9-pin${hub === h.id ? " is-active" : ""}`}
                  style={{ left: `${h.x}%`, top: `${h.y}%` }}
                  aria-label={`${h.city}, ${h.region}`}
                  aria-pressed={hub === h.id}
                  onClick={() => setHub(h.id)}
                  onMouseEnter={() => setHub(h.id)}
                  onFocus={() => setHub(h.id)}
                >
                  <span className="gt9-pin__tip">
                    <b>{h.city}</b>
                    {h.region}
                  </span>
                </button>
              ))}
            </div>
            <ul className="gt9-hubs">
              {HUBS.map((h) => (
                <li key={h.id}>
                  <button
                    type="button"
                    data-hub={h.id}
                    className={`gt9-hub${hub === h.id ? " is-active" : ""}`}
                    aria-pressed={hub === h.id}
                    onClick={() => setHub(h.id)}
                    onMouseEnter={() => setHub(h.id)}
                    onFocus={() => setHub(h.id)}
                  >
                    <i>
                      <Icon name="pin" />
                    </i>
                    <span>
                      <b>{h.city}</b>
                      <em>
                        {h.region} · {h.role}
                      </em>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ---------- Latest articles (existing component) ---------- */}
      <BlogHome />

      {/* ---------- Contact band ---------- */}
      <section
        className="gt9-sec gt9-sec--white gt9-sec--cta"
        aria-labelledby="gt9-cta-title"
      >
        <div className="gt9-container">
          <div className="gt9-cta3" data-rv>
            <div>
              <h2 id="gt9-cta-title">
                Get further information by{" "}
                <span className="hl">making contact</span> with our experienced
                IT staff.
              </h2>
              <p className="gt9-cta3__text">
                <b>
                  Schedule an architecture review, infrastructure audit or AMR
                  proof of concept.
                </b>
                Contact us to request a detailed analysis and assessment of your
                plan.
              </p>
            </div>
            <div className="gt9-reach">
              <span className="gt9-reach__icon">
                <Icon name="phone" />
              </span>
              <span className="gt9-reach__label">REACH OUT NOW!</span>
              <a className="gt9-reach__phone" href={" "}>
                {/* {CONTACT.bigPhone} */}
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
